import { ActionContext, ActionTree } from 'vuex';
// import LagerService from '@/service/LagerService'
import LagerService from '@/modules/ewerp/service/LagerService';

import { RootState } from '@/modules/ewerp/store';
import { useEwerpCommonStore } from '@/modules/ewerp/store/ewerpCommonStore';

import { State } from './state';

import { Mutations, MutationTypes } from './mutations';

import { Maschine } from '@/modules/ewerp/models/MaschinenModels';

export enum ActionTypes {
  GetMaschinen = 'GETMASCHINEN',
}

type ActionArguments = Omit<ActionContext<State, RootState>, 'commit'> & {
  commit<K extends keyof Mutations>(key: K, payload: Parameters<Mutations[K]>[1]): ReturnType<Mutations[K]>;
};

export type Actions = {
  [ActionTypes.GetMaschinen](context: ActionArguments): Promise<void>;
};

export const actions: ActionTree<State, RootState> & Actions = {
  async [ActionTypes.GetMaschinen]({ commit }) {
    const commonStore = useEwerpCommonStore();
    const status = commonStore.status;
    status.maschinenLoading = true;
    commonStore.setStatus(status);

    // return LagerService.getLagerMaschinen()
    return LagerService.getMaschinen()
      .then((res) => {
        status.maschinenLoading = false;
        commonStore.setStatus(status);

        const result: Array<Maschine> = res.data;
        commit(MutationTypes.GetMaschinenSuccess, result);
      })
      .catch((error) => {
        status.maschinenLoading = false;
        // console.log(error);
        if (error.message === 'Network Error') {
          status.maschinenErrorMsg = error.message;
        } else if (error.response?.status == 401) {
          status.maschinenErrorMsg = 'Sie haben keinen Zugriff auf diese Daten';
        } else {
          status.maschinenErrorMsg = error;
        }

        sessionStorage.removeItem('maschinen');
        commonStore.setStatus(status);
      });
  },
};
